import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { PaginaActualService } from 'src/app/services/comunication/pagina-actual.service';
import { Router } from '@angular/router';
import { ToolbarService } from 'src/app/services/comunication/toolbar.service';
import { AuthService } from 'src/app/services/firebase/auth.service';
import { NoderestapiService } from 'src/app/services/noderestapi.service';

// Charts
import { ChartType } from 'chart.js';
import { MultiDataSet, Label } from 'ng2-charts';

@Component({
	selector: 'app-landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
	chats: any
	botones: any
	user

	cantidadRegistros
	cantidadVerificados
	mejoresGestores
	ultimosGestores


	// Doughnut
	public doughnutChartLabels: Label[] = ['Porcentaje verificado', 'Porcentaje sin verificar'];

	public doughnutChartData: MultiDataSet = [
	  [75, 25]
	];

	public doughnutChartType: ChartType = 'doughnut';

	

	constructor(
		private _paginaActualService: PaginaActualService,
		private _router: Router,
		private _toolbarService: ToolbarService,
		private _authService: AuthService,
		private _changeDetectorRef: ChangeDetectorRef, 
		private _api:NoderestapiService, 
		private ngZone:NgZone
	) {

		// Se comentó esta línea porqué no se están llamando a los chats
		// this.getChats()



		this._authService._auth.onAuthStateChanged(response => {
			this.ngZone.run(()=>{
				console.log("Hay respuesta dentro del modulo landing", response);
				this.user = response
			});
		})



		this._toolbarService.page.emit('home')

		this.getCantidadRegistros();
		this.getCantidadVerificados();
		this.traerMejoresGestores();
		this.traerUltimosGestores();
	}


	// events
	public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
		console.log(event, active);
	  }
	
	  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
		console.log(event, active);
	  }





	ngOnInit(): void {
		this._paginaActualService.setPaginaActual()
		this._toolbarService.dataToolbar.emit(this._router.url)
	}



	getChats() {
		this._api.getData('chats').subscribe(data=>{
			this.chats = data;
			console.log("Obteniendo data from api", this.chats)
		})
	}


	traerMejoresGestores(){
		this._api.traerMejoresGestores().subscribe(data=>{
			this.mejoresGestores = data['data'];
			console.log("Mejores Gestores", this.mejoresGestores)
		})
	}


	traerUltimosGestores(){
		this._api.traerUltimosGestores().subscribe(data=>{
			this.ultimosGestores = data['data'];
			console.log("Últimos Gestores", this.traerUltimosGestores)
		})
	}


	createAnoymousUser(item) {
		this._authService._auth.signInAnonymously().then(response => {
			console.log("La respuesta anónima es: ", response)
			this.loadChat(item, response['user'])
		})
	}



	clickChat(item) {

		if (this.user === null) {
			console.log("No hay sesión")
			this.createAnoymousUser(item)
		} else {
			console.log("la sessión actual es: ", this.user)
			this.loadChat(item, this.user)
		}

	}



	getCantidadRegistros(){
		this._api.getCantidadRegistros().subscribe(response => {
			console.log("Trayendo registros", response);

			this.cantidadRegistros = response['data'][0]['cuantos'];
		});
	}


	getCantidadVerificados(){
		this._api.getCantidadVerificados().subscribe(response => {
			console.log("Trayendo registros", response);

			this.ngZone.run(()=>{
				this.cantidadVerificados = response['data'][0]['cuantos'];
			});

		});
	}


	loadChat(item, user) {
		console.log("Lo que se recibe como user es: ", user)
		item.senderUid = user['uid']
		item.senderDisplayName = this.user.isAnonymous ? "Anónimo - " + user['uid'] : user['displayName']
		item.senderPhotoURL = user['photoURL']
		item.senderIsAnonymous = user['isAnonymous']

		console.log("En este punto se abriría con: ", item)
		this._router.navigate(['chat-view'], { queryParams: item })
	}
}
